/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilitiesGroupSubgroupSpec } from './capabilitiesGroupSubgroupSpec';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface CapabilityGlobalDeleteSpec { 
    service_type: ServiceTypeEnum;
    /**
     * If set to true, the API deletes all the Global Capabilities.
     */
    delete_all?: boolean;
    capabilities?: Array<CapabilitiesGroupSubgroupSpec>;
}
export namespace CapabilityGlobalDeleteSpec {
}


